module.exports = __webpack_public_path__ + "img/segment.1986dbde.png";